import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { usePageTitle } from '../../logic';
import { LoadingScreen } from '../shared';

export function RegisterUser({auth0TicketId, companyIdOrderIdHash}: {
  auth0TicketId?: string
  companyIdOrderIdHash?: string
}) {
  usePageTitle('Connecting to your transaction... counting shiplap walls');
  const { loginWithRedirect } = useAuth0();

  if(auth0TicketId){
    loginWithRedirect({
      invitation: auth0TicketId,
      appState: {
        returnTo: `/closings/${companyIdOrderIdHash}`
      }
    });
    return <LoadingScreen/>;
  }
  else{
    let to;

    if(companyIdOrderIdHash){
      to = `/closings/${companyIdOrderIdHash}`;
    }
    else{
      to = "/closings/";
    }
    return <Navigate to={to} />;
  }
}
